import { ServerResponse } from '@/interfaces/Server';
import { logger } from '@/util/logger';

const post = async (url: string, data?: string | unknown): Promise<Response> => {
    const processedData = data ?
        typeof data === 'string' ? data : JSON.stringify(data) :
        null;

    return await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: processedData
    });
};

const parseData = (resp: Response): Promise<ServerResponse> => {
    return resp.json()
        .then((json) => {
            logger.log(json);
            return json.d;
        });
};

class RejectException extends Error {
    constructor(message) {
        super(message); 
        this.name = 'ServerResponseReject'; 
    }
}

const validateResponse = (resp: ServerResponse): ServerResponse => {
    const { Status, Message } = resp;
    if (Status === 'reject') {
        throw new RejectException(Message);
    }

    if (Status === 'error') {
        throw new Error();
    }

    return resp;
};

export {
    RejectException,
    parseData,
    post,
    validateResponse,
};
